import { useEffect, useState } from 'react';

import { useMutation } from '@tanstack/react-query';

import { useUpdatePlanOptions } from '@/entities/subscription';
import { useSheetStore } from '@/shared/stores/sheet-store';

const MANAGE_PLAN_SHEET_TYPE = 'subscription/manage-plan';

export function useUpdatePlan() {
    const [selectedPlanCode, setSelectedPlanCode] = useState<string | null>(null);
    const closeAllSheets = useSheetStore((state) => state.closeAllSheets);
    const isPanelOpen = useSheetStore(
        (state) => state.currentSheet?.type === MANAGE_PLAN_SHEET_TYPE,
    );
    const updatePlan = useMutation(useUpdatePlanOptions());

    // The sheet host stays mounted across open/close, so a prior selection would
    // otherwise reappear on the next open — reset it whenever the panel is closed.
    useEffect(() => {
        if (!isPanelOpen) {
            setSelectedPlanCode(null);
        }
    }, [isPanelOpen]);

    const selectPlan = (planCode: string) => {
        updatePlan.reset();
        setSelectedPlanCode(planCode);
    };

    const clearSelection = () => {
        setSelectedPlanCode(null);
    };

    const confirm = () => {
        if (!selectedPlanCode || updatePlan.isPending) return;
        updatePlan.mutate({ planCode: selectedPlanCode }, { onSuccess: closeAllSheets });
    };

    return {
        selectedPlanCode,
        selectPlan,
        clearSelection,
        confirm,
        isConfirming: updatePlan.isPending,
        error: updatePlan.error,
    };
}
